// The frame's paint: the card's radius, border, and surface, without the
// clipping. An element that scrolls its own content takes this rather than the
// full frame, so its `overflow` survives `cn`'s class merge — `overflow-auto`
// already clips to the radius on its own.
export const TABLE_FRAME_SURFACE_CLASS =
  "rounded-md border border-coval-border bg-surface-default"

// Frame for a table area: a card on the standard radius, bordered on every
// side. `Table`'s `framed` prop applies it to the table itself; a page whose
// table controls sit above the table applies it to the region wrapping both, so
// the frame opens at the controls rather than between them and the rows.
export const TABLE_FRAME_CLASS = `overflow-hidden ${TABLE_FRAME_SURFACE_CLASS}`

// Insets the card from the shell's right and bottom edges by the 24px shell
// gutter — the same one the sidebar keeps to the left of its nav and below its
// footer, and the page header keeps to the right of its trailing actions — so
// the table doesn't run into the window edge. Sized off its own height/width so
// it holds whether the region is laid out as a flex child or a plain block.
const TABLE_INSET_CLASS =
  "mr-6 mb-6 h-[calc(100%-1.5rem)] w-[calc(100%-1.5rem)]"

// What a full-page table view puts on its region: the card, inset from the
// shell. A table card nested inside a page (a split pane, a tab) takes
// TABLE_FRAME_CLASS on its own and leaves the gutter to its container.
export const TABLE_CARD_CLASS = `${TABLE_FRAME_CLASS} ${TABLE_INSET_CLASS}`

// Focus ring for a region that wraps a table card — the focusable fallback a
// drawer returns focus to, say. The card is opaque and starts at the region's
// top and left edges, so a ring on the region itself is painted over there;
// this draws the ring in an overlay above the card, on the card's own rect, so
// it reads on every edge. The element taking it needs `relative` of its own.
export const TABLE_CARD_FOCUS_RING_CLASS =
  "focus-visible:outline-none focus-visible:after:pointer-events-none focus-visible:after:content-[''] focus-visible:after:absolute focus-visible:after:inset-0 focus-visible:after:mr-6 focus-visible:after:mb-6 focus-visible:after:rounded-md focus-visible:after:ring-2 focus-visible:after:ring-inset focus-visible:after:ring-coval-border-active"
